import React from "react";
import Contacts from "./Contacts/Contacts";
import { Container } from "@mui/material";
import Skills from "./Skills/Skills.js";
import Greeting from "./Greeting/Greeting";
import Education from "./Education/Education";
import Experience from "./Experience/Experience";
import ProjectsSlider from "./Projects/ProjectsSlider";

const ENresume = () => {
  return (
    <>
      <Greeting />
      <Container maxWidth="lg">
        <Education />
        <Experience />
        <ProjectsSlider />
      </Container>
      <div className="page-decoration-1"></div>
      <Container maxWidth="lg">
        <Skills />
        <Contacts />
      </Container>
    </>
  );
};
export default ENresume;
